/*
 * File: cell-translation-job-language.ts
 * Created: 2026-01-22
 * Author: Val Liu
 */

import { Component } from "vue-property-decorator";
import { BaseTableBodyCell } from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";

@Component
export default class CellTranslationJobLanguage extends BaseTableBodyCell {
    get sourceLabel() {
        const code = String(this.row?.sourceLang ?? "").toUpperCase();
        return code === "AUTO" ? "AUTO" : code || "-";
    }

    get targetLabel() {
        const code = String(this.row?.targetLang ?? "").toUpperCase();
        return code || "-";
    }
}
